import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import CounterpartiesDt from '@/services/dataTransferModules/counterpartiesDt'

export default function useCounterparties() {
	const counterpartiesDt = new CounterpartiesDt()

	const { t: $t } = useI18n()

	const {
		loadEntityFlags: flags,

		entities: fullCounterparties,
		getEntities: getFulledCounterparties,

		extendedEntities: extendedCounterparties,
		getExtendedEntities: getExtendedCounterparties,

		basedEntities: baseCounterparties,
		getBasedEntities: getBasedCounterparties,

		hashedBasedEntities: hashedBaseCounterparties,
		getHashedBasedEntities: getHashedBasedCounterparties,

		createEntity: createCounterparty,

		entity: counterparty,
		getEntity: getCounterparty,

		entityPopup: counterpartyPopup,
		getEntityPopup: getCounterpartyPopup,

		entityPreview: counterpartyPreview,
		getEntityPreview: getCounterpartyPreview,

		patchEntity: updateCounterparty,
		updateEntity: fullUpdateCounterparty,

		deleteEntity: deleteCounterparty,
	} = useBlProviders(
		counterpartiesDt,
		Object.assign({
			showErrorNotificationForLoadingAllEntities: true,
			errorNotificationTextForLoadingAllEntities: $t('Error loading counterparty'),

			showErrorNotificationForCreatingEntity: true,

			showErrorNotificationForLoadingOneEntity: true,

			showErrorNotificationForUpdatingEntity: true,
			errorNotificationTextForUpdatingEntity: $t('Couldn`t edit a counterparty. Please contact technical support team.'),

			showErrorNotificationForDeletingEntity: true,
		})
	)

	return {
		flags,
		fullCounterparties,
		baseCounterparties,
		hashedBaseCounterparties,
		extendedCounterparties,
		counterpartyPreview,
		counterpartyPopup,
		counterparty,
		getBasedCounterparties,
		getHashedBasedCounterparties,
		getExtendedCounterparties,
		getFulledCounterparties,
		getCounterpartyPreview,
		getCounterpartyPopup,
		getCounterparty,
		createCounterparty,
		deleteCounterparty,
		updateCounterparty,
		fullUpdateCounterparty,
	}
}
